import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'm13.352 4.623-1.98-1.97a1.8 1.8 0 0 0-2.48 0l-6.24 6.24a1.762 1.762 0 0 0 0 2.48l1.98 1.97a1.75 1.75 0 0 0 2.47 0l6.25-6.24a1.762 1.762 0 0 0 0-2.48Zm-1.07 1.42-6.24 6.24a.242.242 0 0 1-.35 0l-1.98-1.97a.275.275 0 0 1-.07-.18.259.259 0 0 1 .07-.18l.59-.59 1.13 1.12a.71.71 0 0 0 .53.22.742.742 0 0 0 .53-.22.754.754 0 0 0 0-1.06L5.362 8.3l.94-.94.38.38a.757.757 0 0 0 .53.21.775.775 0 0 0 .53-.21.767.767 0 0 0 0-1.07l-.37-.37.75-.76 1.12 1.12a.742.742 0 0 0 .53.22.71.71 0 0 0 .53-.22.737.737 0 0 0 0-1.06l-1.12-1.12.78-.77a.2.2 0 0 1 .17-.07.23.23 0 0 1 .18.07l1.98 1.98a.238.238 0 0 1 .07.17.249.249 0 0 1-.08.183Z';
const draw24px =
  'M21.54,7,17,2.4a1.73,1.73,0,0,0-2.47,0L12.76,4.13l-.06,0L7.11,9.77,7,9.86l0,.06L4.29,12.59,2.34,14.54a1.73,1.73,0,0,0,0,2.47L6.92,21.6a1.76,1.76,0,0,0,2.48,0L21.54,9.46A1.73,1.73,0,0,0,21.54,7ZM20.48,8.4,8.34,20.54a.24.24,0,0,1-.35,0L3.4,16a.24.24,0,0,1,0-.35l1.42-1.42,2.39,2.39a.74.74,0,0,0,.53.22.71.71,0,0,0,.53-.22.74.74,0,0,0,0-1.06L5.88,13.12,7.61,11.4l1.07,1.07a.75.75,0,0,0,.53.22.79.79,0,0,0,.53-.22.75.75,0,0,0,0-1.06L8.67,10.34l1.72-1.73L12.78,11a.74.74,0,0,0,.53.22.71.71,0,0,0,.53-.22.74.74,0,0,0,0-1.06L11.45,7.55l1.73-1.72L14.25,6.9a.75.75,0,0,0,.53.22.79.79,0,0,0,.53-.22.75.75,0,0,0,0-1.06L14.24,4.77l1.3-1.31a.24.24,0,0,1,.18-.07.22.22,0,0,1,.17.07l4.59,4.59A.24.24,0,0,1,20.48,8.4ZM12.7,4.18l-.09.09,0,0ZM7.11,9.77,7,9.86l.05-.06Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const RulerIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'ruler'),
) as IconWithRender;

RulerIcon.displayName = 'RulerIcon';
RulerIcon.propTypes = Icon.propTypes;
RulerIcon.renderIcon = (props) => <RulerIcon {...props} />;
export default RulerIcon;
